import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true, state: {
        loading: false,
        properties: {data: [], current_page: 1, total: 0, per_page: 10},
        previewing: false,
        preview: null,
        requesting_otp: false,
        confirming: false,
        settlements: {data: [], current_page: 1, total: 0, per_page: 10},
    }, getters: {
        loading: state => state.loading,
        properties: state => state.properties,
        previewing: state => state.previewing,
        preview: state => state.preview,
        requesting_otp: state => state.requesting_otp,
        confirming: state => state.confirming,
        settlements: state => state.settlements,
    }, mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setProperties(state, data) {
            state.properties = data
        },
        setPreviewing(state, val) {
            state.previewing = val
        },
        setPreview(state, data) {
            state.preview = data
        },
        setRequestingOtp(state, val) {
            state.requesting_otp = val
        },
        setConfirming(state, val) {
            state.confirming = val
        },
        setSettlements(state, data) {
            state.settlements = data
        },
    }, actions: {
        async getPropertiesSummary({commit}, filters) {
            try {
                commit('setLoading', true)
                const response = await api.getPropertiesSummary(filters);
                commit('setProperties', response.data);
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },

        async previewSettlement({commit}, data) {
            try {
                commit('setPreviewing', true)
                commit('setPreview', null)
                const response = await api.previewSettlement(data);
                commit('setPreview', response.data);
                commit('setPreviewing', false)
                return response.data;
            } catch (e) {
                commit('setPreviewing', false)
                ElMessage.error(e.response.data.message);
                return null;
            }
        },

        async requestSettlementOtp({commit}, data) {
            try {
                commit('setRequestingOtp', true)
                await api.requestSettlementOtp(data);
                commit('setRequestingOtp', false)
                ElMessage.success('Confirmation code sent.');
                return true;
            } catch (e) {
                commit('setRequestingOtp', false)
                ElMessage.error(e.response.data.message);
                return false;
            }
        },

        async confirmSettlement({commit}, data) {
            try {
                commit('setConfirming', true)
                const response = await api.confirmSettlement(data);
                commit('setConfirming', false)
                ElMessage.success(response.message || 'Settlement processed successfully!');
                return response;
            } catch (e) {
                commit('setConfirming', false)
                ElMessage.error(e.response.data.message);
                throw e;
            }
        },

        async getSettlements({commit}, filters) {
            try {
                commit('setLoading', true)
                const response = await api.getSettlements(filters);
                commit('setSettlements', response.data);
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },
    }
}
